<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div class="text-center border-bottom pb-2">
          <!--  <p class="p-0 m-0">বিসমিল্লাহির রাহমানির রাহিম</p>
          <h2 class="p-0 m-0">সোহাগ এন্টারপ্রাইজ</h2>
          <h5 class="p-0">হাউসপুর, আলমডাঙ্গা, চুয়াডাঙ্গা।</h5> -->
        </div>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col cols="8">
        <b-form inline>
          <label class="mr-2" for="inline-form-input-name">ইংরেজী তারিখ:</label>
          <datepicker :highlighted="{ days: [5] }" input-class="form-control" v-model="selectedDate"
            format="dd MMMM yyyy"></datepicker>
        </b-form>

      </b-col>
      <b-col>
        রোজ: <b>{{ days[new Date(selectedDate).getDay()] }}</b>
      </b-col>
    </b-row>

    <b-row v-if="selectedDate">
      <b-col class="border" sm="12" md="4">
        <h4 class="text-center">জমা</h4>
        <DepositModal :identityProp="identity" @receiveDepositData="processDepositData" />
        <table class="table table-bordered table-sm ">
          <tr class="last-row">
            <td>জের
              <template v-if="zerLoading">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </template>
              <template v-else>
                <i class="fas fa-check text-success"></i>
              </template>
            </td>
            <td><input v-model="zer" class="form-control digit-input" /></td>
          </tr>
          <tbody v-for="(item, i) in trxInfo" :key="i">
            <template v-if="item.section == 'deposit'">
              <tr class="last-row">
                <td><router-link class="link-profile" :to="getProfileLink(item.info.type, item.info.id)"> {{
                  item.info.primaryName }} </router-link> - <i> {{ item.info.address }} </i><button v-if="item.id"
                    @click="deleteItem(item)" class="btn btn-sm btn-danger float-right"><span
                      class="fas fa-times"></span></button></td>
                <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(item.amount) }}</td>
              </tr>
            </template>

          </tbody>
          <tfoot class="text-right">
            <tr>
              <td>সর্বমোট জমা</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(depositTotal) }}</td>
            </tr>
            <tr>
              <td>(<i class="bi bi-plus-lg"></i>) সর্বমোট বিক্রয়</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(saleTotal) }}</td>
            </tr>
            <tr>
              <td>জমা <i class="bi bi-plus-lg"></i> বিক্রয়</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(depositWithSalesTotal) }}</td>
            </tr>
            <tr>
              <td>(<i class="bi bi-dash-lg"></i>) বাদ খরচ</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(expenseTotal) }}</td>
            </tr>
            <tr>
              <td>(জমা <i class="bi bi-plus-lg"></i> বিক্রয় <i class="bi bi-dash-lg"></i> বাদ খরচ) আজকের জের</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(todaySummaryTotal) }}</td>
            </tr>
          </tfoot>
        </table>
      </b-col>


      <b-col class="border" sm="12" md="4">
        <h4 class="text-center">খরচ</h4>
        <ExpenseModal :identityProp="identity" :identityListProp="identityList" :productListProp="productList"
          @receiveModalData="processExpenseData"></ExpenseModal>
        <table class="table table-bordered table-sm">

          <tbody v-for="(item, i) in trxInfo" :key="i">
            <template v-if="item.status == 'in'">
              <tr>
                <td colspan="2">প্রোডাক্ট খরিদ: <b>{{ item.info.primaryName }}</b><button v-if="item.id"
                    @click="deleteItem(item)" class="btn btn-sm btn-danger float-right"><span
                      class="fas fa-times"></span></button></td>
              </tr>
              <tr>
                <td>দর <span class="bn-number">{{ AmountService.commaDecimalWithCurrency(item.purchaseRate) }}</span> x
                  পরিমান <span class="bn-number">{{ AmountService.comma(item.quantity) }} </span></td>
                <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(item.total) }}</td>
              </tr>
              <tr>
                <td>লেবার খরচ</td>
                <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(item.laborCost) }}</td>
              </tr>
              <tr class="last-row">
                <td>গাড়িভাড়া</td>
                <td class="bn-number text-right">{{
                  AmountService.commaDecimalWithCurrency(item.transportationCost)
                  }}
                </td>
              </tr>
            </template>

            <template v-else>
              <template v-if="item.section == 'expense'">
                <tr class="last-row">
                  <td><router-link class="link-profile" :to="getProfileLink(item.info.type, item.info.id)"> {{
                    item.info.primaryName }} </router-link> - <i> {{ item.info.address }} </i><button v-if="item.id"
                      @click="deleteItem(item)" class="btn btn-sm btn-danger float-right"><span
                        class="fas fa-times"></span></button></td>
                  <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(item.amount) }}</td>
                </tr>
              </template>
            </template>

          </tbody>
          <tfoot>
            <tr>
              <td>সর্বমোট খরচ</td>
              <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(expenseTotal) }}</td>
            </tr>
          </tfoot>
        </table>
      </b-col>



      <b-col class="border" sm="12" md="4">
        <h4 class="text-center">বিক্রয়</h4>
        <SaleModal @receiveSaleData="processSaleData" :productListProp="productList" />
        <table class="table table-sm table-bordered">
          <tbody>
            <!-- <template  v-for="(cat, index) in $config.category">
          <tr  :key="index">
            <td colspan="2"><h5 class="font-weight-bold"> {{cat.category_name}} </h5></td>
          </tr>

          <tr v-for="(item, i) in trxInfo.filter(v=>(v.info.type === 'cement') && (v.status === 'out'))" :key="index">
            <td>{{ item.info.primaryName }}: দর <span
                class="bn-number">{{ AmountService.commaDecimalWithCurrency(item.saleRate) }}</span> x পরিমান <span
                class="bn-number">{{ AmountService.commaDecimal(item.quantity) }}</span><button v-if="item.id"  @click="deleteItem(item)" class="btn btn-sm btn-danger float-right"><span class="fas fa-times"></span></button></td>
            <td class="text-right bn-number">{{ AmountService.commaDecimalWithCurrency(item.amount) }}</td>
          </tr>
          <tr   :key="index">
            <td class="text-right">মোট সিমেন্ট বিক্রয়</td>
            <td class="text-right bn-number font-weight-bold">{{ AmountService.commaDecimalWithCurrency(cementTotal) }}</td>
          </tr>
          </template> -->


            <template v-for="(cat, catIndex) in $config.category">
              <tr :key="'header-' + catIndex">
                <td colspan="2">
                  <h5 class="font-weight-bold">{{ cat.category_name }}</h5>
                </td>
              </tr>

              <tr v-for="(item, i) in trxInfo.filter(v => v.info.type === cat.category_slug && v.status === 'out')"
                :key="item.id || 'item-' + i + '-' + catIndex">
                <td>
                  {{ item.info.primaryName }}: দর
                  <span class="bn-number">{{ AmountService.commaDecimalWithCurrency(item.saleRate) }}</span> x পরিমান
                  <span class="bn-number">{{ AmountService.commaDecimal(item.quantity) }}</span>
                  <button v-if="item.id" @click="deleteItem(item)" class="btn btn-sm btn-danger float-right">
                    <span class="fas fa-times"></span>
                  </button>
                </td>
                <td class="text-right bn-number">
                  {{ AmountService.commaDecimalWithCurrency(item.amount) }}
                </td>
              </tr>

              <tr :key="'footer-' + catIndex">
                <td class="text-right">মোট {{ cat.category_name }} বিক্রয়</td>
                <td class="text-right bn-number font-weight-bold">
                  {{ AmountService.commaDecimalWithCurrency(getProductSaleTotal(cat.category_slug)) }}
                </td>
              </tr>
            </template>

            <tr>
              <td class="text-right font-weight-bold">মোট {{  getProductPhraseTotal }} বিক্রয়</td>
              <td class="text-right bn-number font-weight-bold">{{
                AmountService.commaDecimalWithCurrency(saleTotal)
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-sm table-bordered">
          <thead>
            <th colspan="2">আজকের বিক্রয়ের সারমর্ম:</th>
          </thead>
          <tbody>
            <tr>
              <td>সর্বমোট বিক্রয়</td>
              <td class="bn-number">{{ AmountService.commaDecimalWithCurrency(saleTotal) }}</td>
            </tr>
            <tr>
              <td>সর্বমোট বিক্রয় (কথায়)</td>
              <td>{{ AmountService.toWordCurrency(saleTotal) }}</td>
            </tr>
            <tr>
              <td>বিক্রয় হতে লাভ</td>
              <td class="bn-number font-weight-bold">{{ AmountService.commaDecimalWithCurrency(profitTotal) }}</td>
            </tr>
          </tbody>

        </table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ExpenseModal from '../components/DailyRegistryComponents/ExpenseModal.vue';
import AmountService from "../services/amountService";
import SaleModal from "@/components/DailyRegistryComponents/SaleModal.vue";
import DepositModal from "@/components/DailyRegistryComponents/DepositModal.vue";
import Identity from "@/services/DataStructure/Identity";
import IdentityType from "@/services/DataStructure/IdentityType";
import Datepicker from 'vuejs-datepicker';
// import TransactionInfo from "@/services/DataStructure/TransactionInfo";
import Product from "@/services/DataStructure/Product/Product";
// import BlackBox from "@/services/BlackBox";
import { firebase } from "@/firebase"
export default {

  data() {
    return {
      zer: "",
      zerLoading: false,
      zerUpdate: false,
      selectedDate: "",
      selectedDateFormatted: "",
      identity: [],
      identityList: [],
      productList: [],
      trxInfo: [],
      masterTrxInfo: [],
      sales: [],
      days: [
        'রবিবার',
        'সোমবার',
        'মঙ্গলবার',
        'বুধবার',
        'বৃহস্পতিবার',
        'শুক্রবার',
        'শনিবার'
      ],
      fridayOff: {
        highlighted: {
          days: [5], // Highlight Friday\
        }
      }
    };
  },
  components: {
    DepositModal,
    SaleModal,
    ExpenseModal,
    Datepicker
  },
  methods: {
    getProductSaleTotal(productSlug) {
      return this.calculateTotal(this.trxInfo.filter(v => (v.info.type === productSlug) && (v.status === 'out')))
    },
    async deleteItem(item) {
      let trxDeletePassword = prompt("আপনি কি এই লেনদেন মুছে দিতে নিশ্চিত? নিশ্চিত হলে পাসওয়ার্ড প্রবেশ করান")
      try {
        this.$swal.showLoading()
        const response = await this.$http.delete(`/api/trxInfo/` + item.id, { data: { "delete_password": trxDeletePassword } });
        if (response.status === 202) {
          let localLoc = this.trxInfo.findIndex(x => x.id === item.id)
          this.trxInfo.splice(localLoc, 1)
          this.$swal('Success!!!', "লেনদেনের তথ্য সফলভাবে মুছে ফেলা হয়েছে", response.data.status);
          firebase.analytics().logEvent("DeleteEntry", { deleteInfo: item, date: new Date().toISOString().split('T')[0], timestamp: new Date() })
        } else {
          this.$swal('গোলযোগ দেখা দিয়েছে', "তথ্য মুছে ফেলা যায়নি", response.data.status);
        }
      } catch (error) {
        console.log(error);
        this.$swal(error)
      }
    },
    getProfileLink: function (type, id) {
      return "/" + type + "/" + id
    },
    // Need to refactor
    async processExpenseData(data) {
      data.date = this.selectedDateFormatted
      data.section = 'expense'
      try {
        const response = await this.$http.post(`/api/daily/expense`, data);
        if (response.status === 201) {
          this.trxInfo.push(data)
          this.$swal('Success!!!', "তথ্য সফলভাবে যোগ হয়েছে", response.data.status);
          firebase.analytics().logEvent("ExpenseEntry", { expenseInfo: data, date: new Date().toISOString().split('T')[0], timestamp: new Date() })
        } else {
          this.$swal('গোলযোগ দেখা দিয়েছে', "তথ্য যোগ করা যায়নি", response.data.status);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // Need to refactor
    async processSaleData(data) {
      data.date = this.selectedDateFormatted
      data.section = 'sale'
      try {
        const response = await this.$http.post(`/api/daily/stock/out`, data);
        if (response.status === 201) {
          this.trxInfo.push(data)
          this.$swal('Success!!!', "তথ্য সফলভাবে যোগ হয়েছে", response.data.status);
          firebase.analytics().logEvent("SaleEntry", { saleInfo: data, date: new Date().toISOString().split('T')[0], timestamp: new Date() })
        } else {
          this.$swal('গোলযোগ দেখা দিয়েছে', "তথ্য যোগ করা যায়নি", response.data.status);
        }
      } catch (error) {
        console.log(error);
      }
    },


    async processDepositData(data) {
      data.date = this.selectedDateFormatted
      data.section = 'deposit'
      try {
        const response = await this.$http.post(`/api/daily/deposit`, data);
        if (response.status === 201) {
          this.trxInfo.push(data)
          this.$swal('Success!!!', "তথ্য সফলভাবে যোগ হয়েছে", response.data.status);
          firebase.analytics().logEvent("DepositEntry", { depositInfo: data, date: new Date().toISOString().split('T')[0], timestamp: new Date() })
        } else {
          this.$swal('গোলযোগ দেখা দিয়েছে', "তথ্য যোগ করা যায়নি", response.data.status);
        }
      } catch (error) {
        console.log(error);
      }
      //TransactionInfo.addTrxInfo(this.masterTrxInfo)
      //
      // localStorage.setItem('deposit', JSON.stringify(this.masterDeposit))
    },

    calculateTotal: function (arr) {
      if (arr.length > 0) {
        return arr.reduce((p, a) => p + parseFloat(a.amount), 0)
      } else {
        return 0
      }
    },
    calculateProfit() {
      console.log(this.trxInfo.filter(x => x.date === this.selectedDateFormatted && x.status === "out"))
      return this.trxInfo.filter(x => x.date === this.selectedDateFormatted && x.status === "out").reduce((sum, v) => sum + v.profit, 0);
    },

    processIdentityOption(identityType) {

      identityType.forEach(x => {

        let optionText;
        switch (x) {
          case IdentityType.CUSTOMER:
            optionText = "কাস্টমার";
            break;
          case IdentityType.SUPPLIER:
            optionText = "সাপ্লাইয়ার";
            break;
          case IdentityType.VEHICLE:
            optionText = "ট্রাক";
            break;
          case IdentityType.CONTRACT:
            optionText = "ঠিকাদারী কাজ";
            break;
          case IdentityType.BANK:
            optionText = "ব্যাংক একাউন্ট";
            break;
          case IdentityType.THIRD_PARTY:
            optionText = "থার্ড পার্টি";
            break;
          case IdentityType.HARVEST:
            optionText = "ফসল";
            break;
          case IdentityType.EXPENSE:
            optionText = "খরচের তালিকা";
            break;
          case IdentityType.DRAWING:
            optionText = "ব্যক্তিগত উত্তোলনের তালিকা";
            break;
          case IdentityType.PROFIT:
            optionText = "লভ্যাংশের তালিকা";
            break;

        }
        this.identity.push({ value: x, text: optionText })
      });

    }
  },
  async mounted() {
    this.processIdentityOption(Identity.getIdentityTypes())
    this.identityList = await Identity.getIdentities()
    console.log(this.identityList)
    this.productList = await Product.getProducts()
    // this.masterTrxInfo = await TransactionInfo.getTrxInfo()
  },
  async created() {
    this.processIdentityOption(Identity.getIdentityTypes())
    this.identityList = await Identity.getIdentities()
    console.log(this.identityList)
    this.productList = await Product.getProducts()
    // this.masterTrxInfo = await TransactionInfo.getTrxInfo()
  },
  watch: {
    async selectedDate(val) {
      firebase.analytics().logEvent("DailyEntryDate", { entryDate: val, date: new Date().toISOString().split('T')[0], timestamp: new Date() })
      this.processIdentityOption(Identity.getIdentityTypes())
      this.productList = await Product.getProducts()
      this.zerUpdate = false
      let dailyData;
      let sDate = new Date(val)
      this.selectedDateFormatted = sDate.getDate() + "-" + (sDate.getMonth() + 1) + "-" + sDate.getFullYear()
      let selfDate = this.selectedDateFormatted.split("-")
      let year = selfDate[2]
      let month = selfDate[1]
      if (month > 0 && month < 10) {
        month = "0" + month
      }
      let date = selfDate[0]
      if (date > 0 && date < 10) {
        date = "0" + date
      }
      let isoDate = date + "-" + month + "-" + year
      console.log(isoDate)

      this.$swal.showLoading();
      try {
        dailyData = await this.$http.get(`/api/daily/` + this.selectedDateFormatted);
        //console.log(productData.data.zerData);
      } catch (error) {
        console.log(error)
        return error;
      }
      this.$swal.close();
      if (dailyData.data.zer != null) {
        this.zer = dailyData.data.zer
      } else {
        this.zer = ""
      }

      this.zerUpdate = true

      this.trxInfo = dailyData.data.trxInfo
      console.log("this.zer")
      console.log(this.zer)
    },
    zer() {
      // I need to set a variable (boolean) so that it can detect whether it is initial zer or updated zer, task is pending.
      this.zerLoading = true
      if (this.zerUpdate) {
        this.$http.post(`/api/daily/zer`, { "date": this.selectedDateFormatted, "zer": this.zer })
          .then(response => {
            if (response.data.status === 'success' || response.data.status === 'update') {
              this.zerLoading = false
            } else {
              console.error(response.statusText);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }

      //Old Code with Local Storage
      /*
      let zerArray = JSON.parse(localStorage.getItem("zer"))
      if(zerArray){
        const pos = zerArray.map(e => e.date).indexOf(this.selectedDateFormatted)
        if(pos===-1){
          zerArray.push({date: this.selectedDateFormatted, zer: this.zer})
          localStorage.setItem("zer", JSON.stringify(zerArray))
        }else{
          zerArray[pos].zer = this.zer
          localStorage.setItem("zer", JSON.stringify(zerArray))
        }
      }else{
        localStorage.setItem("zer", JSON.stringify([{date: this.selectedDateFormatted, zer: this.zer}]))
      }
        */
    }
  },
  computed: {
    AmountService() {
      return AmountService
    },
    expenseTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(x => x.section === 'expense'))
    },
    cementTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(v => (v.info.type === "cement") && (v.status === 'out')))
    },
    steelTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(v => (v.info.type === "steel") && (v.status === 'out')))
    },
    hardwareTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(v => (v.info.type === "hardware") && (v.status === 'out')))
    },
    saleTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(v => v.status === "out"))
    },
    profitTotal() {
      return this.calculateProfit().toFixed(2)
    },
    depositTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(x => x.section === 'deposit')) + (parseInt(this.zer) || 0)
    },
    depositWithSalesTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(x => x.section === 'deposit')) + this.calculateTotal(this.trxInfo.filter(v => v.status === "out")) + (parseInt(this.zer) || 0)
    },
    todaySummaryTotal: function () {
      return this.calculateTotal(this.trxInfo.filter(x => x.section === 'deposit')) + this.calculateTotal(this.trxInfo.filter(v => v.status === "out")) - this.calculateTotal(this.trxInfo.filter(x => x.section === 'expense')) + (parseInt(this.zer) || 0)
    },
    getDepositSection: function () {
      return this.trxInfo.filter(x => x.section === 'deposit')
    },
    getProductPhraseTotal: function(){
      return this.$config.category.reduce((sum,x) => sum==""?x.category_name:sum+" + "+x.category_name,"")
    }

  }
};
</script>
<style>
.last-row {
  border-bottom: #000000 solid 2px;
}

.date-control {
  width: 20% !important;
}

.link-profile {
  color: black;
}

.link-profile:hover {
  color: black;
}
</style>
